import { Logos } from '@/Static';
import { Pair } from '@/Types';
import { useMemo } from 'react';

export enum MarketplaceType {
  Market = 'Market',
  Manual = 'Manual',
  Ebay = 'Ebay',
  Amazon = 'Amazon',
  Kaufland = 'Kaufland',
  Ozon = 'Ozon',
}

export const useMarketplaceOptions = (excludedKeys?: MarketplaceType[]) => {
  return useMemo(() => {
    return [
      { key: MarketplaceType.Market, value: 'Market' },
      { key: MarketplaceType.Manual, value: 'Manual' },
      { key: MarketplaceType.Ebay, value: 'Ebay' },
      { key: MarketplaceType.Amazon, value: 'Amazon' },
      { key: MarketplaceType.Kaufland, value: 'Kaufland' },
      { key: MarketplaceType.Ozon, value: 'Ozon' },
    ].filter((mp) => !excludedKeys?.length || !excludedKeys.some((a) => a == mp.key));
  }, [excludedKeys]);
};

export const MARKETPLACE_IMAGE_OPTIONS: Pair<MarketplaceType>[] = [
  {
    key: MarketplaceType.Market,
    value: '',
  },
  {
    key: MarketplaceType.Manual,
    value: '',
  },
  {
    key: MarketplaceType.Ebay,
    value: Logos.Ebay,
  },
  {
    key: MarketplaceType.Amazon,
    value: Logos.Amazon,
  },
  {
    key: MarketplaceType.Kaufland,
    value: Logos.Kaufland,
  },
  {
    key: MarketplaceType.Ozon,
    value: Logos.Ozon,
  },
];
